import { Table as MUITable, TableContainer } from '@mui/material';
import React from 'react';
export function Table({ children, className, id, padding, size, stickyHeader }) {
    return (React.createElement(TableContainer, { id: id },
        React.createElement(MUITable, { className: className, padding: padding, size: size, stickyHeader: stickyHeader }, children)));
}
//# sourceMappingURL=Table.js.map